const reducer = (state: WtrState) => ({
  ...state,
  branches: [],
  loading: true,
  isPostcodeInvalid: false,
  error: null,
});

export default reducer;
